import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, ZapIcon, ShieldCheckIcon, ActivityIcon } from 'lucide-react';
export function PricingPage() {
  return <div className="flex flex-col pb-24 bg-landing-bg text-landing-text" data-id="element-979">
      {/* Promo Banner */}
      <div className="bg-landing-surface border-b border-landing-border py-3 px-4 text-center" data-id="element-980">
        <p className="text-sm font-medium text-landing-accent" data-id="element-981">
          🎉 Launch special: Get 50% off setup with code{' '}
          <span className="font-mono bg-landing-card px-2 py-0.5 rounded border border-landing-border ml-1" data-id="element-982">
            LAUNCH50
          </span>
        </p>
      </div>

      {/* Hero */}
      <section className="pt-20 pb-16 px-4 text-center" data-id="element-983">
        <div className="container mx-auto max-w-4xl" data-id="element-984">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-landing-text" data-id="element-985">
            Simple, transparent pricing
          </h1>
          <p className="text-xl text-landing-muted max-w-2xl mx-auto" data-id="element-986">
            Pay once for expert configuration. Add monitoring for ongoing peace
            of mind.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="px-4 mb-24" data-id="element-987">
        <div className="container mx-auto max-w-6xl" data-id="element-988">
          <div className="grid md:grid-cols-3 gap-8 items-stretch" data-id="element-989">
            {/* Free Tier */}
            <div className="bg-landing-card border border-landing-border rounded-2xl p-8 flex flex-col" data-id="element-990">
              <div className="w-12 h-12 rounded-lg bg-landing-surface flex items-center justify-center mb-6" data-id="element-991">
                <ZapIcon className="w-6 h-6 text-landing-text" data-id="element-992" />
              </div>
              <h3 className="text-2xl font-bold mb-2 text-landing-text" data-id="element-993">
                Free
              </h3>
              <p className="text-landing-muted mb-6 h-12" data-id="element-994">
                Configuration & Recommendation
              </p>
              <div className="text-4xl font-bold mb-8 text-landing-text" data-id="element-995">
                $0
              </div>
              <ul className="space-y-4 mb-8 flex-1" data-id="element-996">
                <li className="flex items-start gap-3" data-id="element-997">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-muted shrink-0" data-id="element-998" />
                  <span className="text-landing-text" data-id="element-999">
                    Guided questionnaire
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1000">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-muted shrink-0" data-id="element-1001" />
                  <span className="text-landing-text" data-id="element-1002">
                    Architecture recommendation
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1003">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-muted shrink-0" data-id="element-1004" />
                  <span className="text-landing-text" data-id="element-1005">
                    Preview Stripe modules
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1006">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-muted shrink-0" data-id="element-1007" />
                  <span className="text-landing-text" data-id="element-1008">Data model preview</span>
                </li>
              </ul>
              <Link to="/setup" className="w-full block text-center bg-landing-surface text-landing-text hover:bg-landing-border px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-1009">
                Start Free Setup
              </Link>
            </div>

            {/* Setup Tier */}
            <div className="bg-landing-card border-2 border-landing-accent rounded-2xl p-8 flex flex-col relative shadow-xl shadow-landing-accent/10 scale-105 z-10" data-id="element-1010">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-landing-accent text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-1011">
                Most Popular
              </div>
              <div className="w-12 h-12 rounded-lg bg-landing-accent/10 flex items-center justify-center mb-6" data-id="element-1012">
                <ShieldCheckIcon className="w-6 h-6 text-landing-accent" data-id="element-1013" />
              </div>
              <h3 className="text-2xl font-bold mb-2 text-landing-text" data-id="element-1014">
                Setup
              </h3>
              <p className="text-landing-muted mb-6 h-12" data-id="element-1015">
                Provisioning & Implementation Pack
              </p>
              <div className="flex items-end gap-2 mb-8" data-id="element-1016">
                <span className="text-4xl font-bold text-landing-text" data-id="element-1017">
                  $29
                </span>
                <span className="text-landing-muted mb-1" data-id="element-1018">one-time</span>
              </div>
              <ul className="space-y-4 mb-8 flex-1" data-id="element-1019">
                <li className="flex items-start gap-3" data-id="element-1020">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-accent shrink-0" data-id="element-1021" />
                  <span className="text-landing-text" data-id="element-1022">Everything in Free</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1023">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-accent shrink-0" data-id="element-1024" />
                  <span className="text-landing-text" data-id="element-1025">
                    Automated Stripe provisioning
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1026">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-accent shrink-0" data-id="element-1027" />
                  <span className="text-landing-text" data-id="element-1028">
                    Custom implementation pack
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1029">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-accent shrink-0" data-id="element-1030" />
                  <span className="text-landing-text" data-id="element-1031">
                    Database schema & code snippets
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1032">
                  <CheckCircle2Icon className="w-5 h-5 text-landing-accent shrink-0" data-id="element-1033" />
                  <span className="text-landing-text" data-id="element-1034">
                    Test & Go-Live checklists
                  </span>
                </li>
              </ul>
              <Link to="/setup" className="w-full block text-center bg-landing-accent text-white hover:bg-landing-accent-light px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-1035">
                Get Started
              </Link>
            </div>

            {/* Monitoring Tier */}
            <div className="bg-landing-card border border-landing-border rounded-2xl p-8 flex flex-col" data-id="element-1036">
              <div className="w-12 h-12 rounded-lg bg-pk-info-light flex items-center justify-center mb-6" data-id="element-1037">
                <ActivityIcon className="w-6 h-6 text-pk-info" data-id="element-1038" />
              </div>
              <h3 className="text-2xl font-bold mb-2 text-landing-text" data-id="element-1039">
                Monitoring
              </h3>
              <p className="text-landing-muted mb-6 h-12" data-id="element-1040">
                Ongoing health & drift alerts
              </p>
              <div className="flex items-end gap-2 mb-8" data-id="element-1041">
                <span className="text-4xl font-bold text-landing-text" data-id="element-1042">
                  $19
                </span>
                <span className="text-landing-muted mb-1" data-id="element-1043">/mo</span>
              </div>
              <p className="text-sm text-landing-muted mb-6 -mt-4" data-id="element-1044">
                $9/mo per additional account
              </p>
              <ul className="space-y-4 mb-8 flex-1" data-id="element-1045">
                <li className="flex items-start gap-3" data-id="element-1046">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1047" />
                  <span className="text-landing-text" data-id="element-1048">
                    Webhook health monitoring
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1049">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1050" />
                  <span className="text-landing-text" data-id="element-1051">
                    Configuration drift alerts
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1052">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1053" />
                  <span className="text-landing-text" data-id="element-1054">
                    Stripe update recommendations
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1055">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1056" />
                  <span className="text-landing-text" data-id="element-1057">Dashboard access</span>
                </li>
              </ul>
              <Link to="/setup" className="w-full block text-center bg-landing-surface border border-landing-border text-landing-text hover:bg-landing-card px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-1058">
                Add during setup
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="px-4" data-id="element-1059">
        <div className="container mx-auto max-w-3xl" data-id="element-1060">
          <h2 className="text-2xl font-bold mb-8 text-center text-landing-text" data-id="element-1061">
            Pricing FAQ
          </h2>
          <div className="space-y-6" data-id="element-1062">
            <div className="bg-landing-card border border-landing-border rounded-lg p-6" data-id="element-1063">
              <h4 className="font-semibold mb-2 text-landing-text" data-id="element-1064">
                When do I pay the $29 setup fee?
              </h4>
              <p className="text-landing-muted" data-id="element-1065">
                You only pay after you've completed the questionnaire and
                reviewed your recommended stack. The preview is completely free.
              </p>
            </div>
            <div className="bg-landing-card border border-landing-border rounded-lg p-6" data-id="element-1066">
              <h4 className="font-semibold mb-2 text-landing-text" data-id="element-1067">
                How does the LAUNCH50 discount work?
              </h4>
              <p className="text-landing-muted" data-id="element-1068">
                Enter the code LAUNCH50 during the checkout step to get 50% off
                the one-time setup fee, bringing it down to $14.50.
              </p>
            </div>
            <div className="bg-landing-card border border-landing-border rounded-lg p-6" data-id="element-1069">
              <h4 className="font-semibold mb-2 text-landing-text" data-id="element-1070">
                Is the monitoring plan required?
              </h4>
              <p className="text-landing-muted" data-id="element-1071">
                No, monitoring is completely optional. You can provision your
                stack for a one-time fee and never pay us again. Monitoring is
                for teams who want ongoing alerts if their Stripe configuration
                changes or webhooks fail.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}